import {
  buildConfirmedClauseIds,
  isBidderClauseConfirmed,
} from '../../../shared/offer-domain/respond';

export { buildConfirmedClauseIds };

export const isClauseAccepted = (
  clause,
  clauseResponses = {},
  confirmedClauseIds = {}
) => {
  if (isBidderClauseConfirmed(clauseResponses?.[clause?.id])) return true;
  return Boolean(confirmedClauseIds?.[clause?.id]);
};

export const getUnacceptedClauses = (
  clauses = [],
  clauseResponses = {},
  confirmedClauseIds = {}
) =>
  clauses.filter(
    clause => !isClauseAccepted(clause, clauseResponses, confirmedClauseIds)
  );
